<mat-card class="cardWithShadow theme-card">
    <mat-card-header>
        <mat-card-title class="m-b-0">Change Profile Picture</mat-card-title>
    </mat-card-header>
    <mat-card-content class="b-t-1">
        <div class="d-flex justify-content-center m-b-20">
            <div class="preview-frame">
                <img [src]="previewUrl ?? (data.image | filePath)" alt="Preview" />
            </div>
        </div>

        <app-file-upload [formControl]="fileControl"></app-file-upload>

        <div class="d-flex justify-content-end m-t-20">
            <button mat-stroked-button class="m-r-8" type="button"
                    [disabled]="loading" (click)="onNoClick()">Cancel</button>
            <button mat-flat-button color="primary" type="button"
                    [disabled]="fileControl.invalid || loading" (click)="submit()">
                @if (loading) {
                    <mat-spinner diameter="18" class="d-inline-block m-r-8"></mat-spinner>
                    Uploading...
                } @else {
                    Upload
                }
            </button>
        </div>
    </mat-card-content>
</mat-card>
